import { CompanySource, CompanyStructure, CompanyType } from '../types/enums'

interface CompanyEntityInput {
  company_id?: string
  business_name?: string | null
  businessactivity?: string | null
  auth_user_id?: string
  company_type?: CompanyType | string | null
  designator?: string | null
  doingjob?: string | null
  ein?: string | null
  filing_id?: string | null
  formation_date?: string | null
  formation_state?: string | null
  onboarding_status?: string
  reserved_equity?: number | null
  source?: CompanySource | string | null
  total_shares?: number | null
  company_structure?: CompanyStructure | string | null
  created_at?: string
  updated_at?: string | null
  phone_number?: string | null
  email?: string | null
  website?: string | null
  naics_code?: string | null
}

export class CompanyEntity {
  public company_id: string
  public business_name: string | null
  public businessactivity: string | null
  public auth_user_id: string
  public company_type: CompanyType | null
  public designator: string | null
  public doingjob: string | null
  public ein: string | null
  public filing_id: string | null
  public formation_date: string | null
  public formation_state: string | null
  public onboarding_status: string
  public reserved_equity: number | null
  public source: CompanySource | null
  public total_shares: number | null
  public company_structure: CompanyStructure | null
  public created_at: string
  public updated_at: string | null
  public phone_number: string | null
  public email: string | null

  // Missing fields that the UI expects
  public website: string | null
  public naics_code: string | null

  constructor(company: CompanyEntityInput) {
    this.company_id = company.company_id as string
    this.business_name = company.business_name ?? null
    this.businessactivity = company.businessactivity ?? null
    this.auth_user_id = company.auth_user_id as string
    this.company_type = (company.company_type as CompanyType) ?? null
    this.created_at = company.created_at as string
    this.designator = company.designator ?? null
    this.doingjob = company.doingjob ?? null
    this.ein = company.ein ?? null
    this.filing_id = company.filing_id ?? null
    this.formation_date = company.formation_date ?? null
    this.formation_state = company.formation_state ?? null
    this.onboarding_status = company.onboarding_status as string
    this.reserved_equity = company.reserved_equity ?? null
    this.source = (company.source as CompanySource) ?? null
    this.total_shares = company.total_shares ?? null
    this.company_structure = (company.company_structure as CompanyStructure) ?? null
    this.updated_at = company.updated_at ?? null
    this.phone_number = company.phone_number ?? null
    this.email = company.email ?? null

    // Assign the missing fields
    this.website = company.website || null
    this.naics_code = company.naics_code || null
  }

  get isWaitingForFormation() {
    return this.source === CompanySource.FormedByUs && this.ein === null
  }

  get isFormedByUs() {
    return this.source === CompanySource.FormedByUs
  }

  get isExistingCompany() {
    return this.source === CompanySource.ExistingCompany
  }
}
